<template>
    <div class="matchItem" v-if="data">
        <div class="leftItem">
            <span class="date">{{data.match_time ? data.match_time.substring(5,10) : '-'}}</span>
            <span class="num">{{data.match_time ? data.match_time.substring(10,16) : '-'}}</span>
            <span class="status">
                <em v-if="data.status == 3">已完赛</em>
                <em v-if="data.status == 1">未开始</em>
                <template v-if="data.status == 2">
                    <em v-if="data.status == 2 && data.status_code == 20" style="color: #439E3D;">加时</em>
                    <em v-else-if="data.status == 2 && data.status_code == 25" style="color:#439E3D;">点球</em>
                    <em v-else-if="data.status == 2 && data.status_code == 31" style="color: #207AE0;">中场</em>
                    <em v-else style="color: #439E3D;">进行中</em>
                </template>
                
            </span>
        </div>
        <div class="middleItem">
            <p>
                <span><img :src="data.home_team ?data.home_team.logo_url : ''" alt=""></span>
                <span>{{data.home_team ? data.home_team.team_name : '-'}}</span>
            </p>
            <p>
                <span><img :src="data.away_team ? data.away_team.logo_url : ''" alt=""></span>
                <span>{{data.away_team ? data.away_team.team_name : '-'}}</span>
            </p>
        </div>
        <div class="rightItem">
            <template v-if="data.status == 1">
                <p>-</p>
                <p>-</p>
            </template>
            <template v-else>
                <p :style="{color: color(data)}">{{data.home_team_normal_time_score}}</p>
                <p :style="{color: color(data)}">{{data.away_team_normal_time_score}}</p>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "matchItem",
    props: ['data'],
    methods: {
        color (item) {
            if (item.status == 2) {
                if (item.status == 2 && item.status_code == 31) {
                    return '#207AE0'
                } else {
                    return '#439E3D'
                }
            } else {
                return '#F83131'
            }
        }
    }
}
</script>

<style lang="less">
.matchItem{
    display: flex;
    justify-content: space-between;
    padding: 0 13px;
    height: 82px;
    border-bottom: 1px solid #EEEEEE;
    .leftItem{
        width: 83px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        .date{
            font-size: 14px;
            font-weight: 400;
            color: #333333;
        }
        .num{
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            margin: 5px 0;
            padding-left: 3px;
        }
        .status{
            em{
                font-style: normal;
                font-size: 12px;
                font-weight: 400;
                color: #7A809A;
            }
        }
    }
    .middleItem{
        width: 158px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        p{
            display: flex;
            align-items: center;
            &:last-child{
                margin-top: 10px;
            }
            span{
                &:first-child{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    img{
                        width: 26px;
                        height: 26px;
                        // border-radius: 50%;
                    }
                }
                &:last-child{
                    margin-left: 11px;
                    max-width: 100px;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }
    .rightItem{
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        p{
            display: flex;
            align-items: center;
            font-size: 18px;
            font-weight: 500;
            color: #F83131;
            &:last-child{
                margin-top: 10px;
            }
        }
    }
}
</style>